export default (quests, id) => {
  id = parseInt(id, 10);
  const filtered = quests.filter((quest) => quest.id === id);
  return filtered.length ? filtered[0] : null;
};
